"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../../i18n/i18n");
var _useTheme = require("../../../../theme/utils/useTheme");
var _visuallyhidden = require("../../../visuallyhidden");
var _ActionButton = require("../shared/ActionButton");
var _ToggleButtonIcon = require("./ToggleButtonIcon");
const ToggleButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    clientId,
    hideDropdownArrow,
    isReadonly,
    isHovered,
    isActive,
    isOpen,
    ...rest
  } = _ref;
  const {
    i18n
  } = (0, _i18n.useI18n)();
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const sharedProps = {
    ...rest,
    "aria-label": i18n._( /*i18n*/{
      comment: "This button opens and closes the select menu",
      id: "Toggle menu"
    }),
    ref
  };

  // If the button is readonly, we need to to still be there so we can interact with it.
  // However, we don't want it to be visible at all--same with hideDropdownArrow, by no coincidence.
  return isReadonly || hideDropdownArrow ? /*#__PURE__*/_react.default.createElement(_visuallyhidden.VisuallyHidden, (0, _extends2.default)({
    renderAs: "button"
  }, sharedProps, {
    "aria-disabled": "true"
  }), null) : /*#__PURE__*/_react.default.createElement(_ActionButton.ActionButton, (0, _extends2.default)({}, sharedProps, {
    // Pass isDisabled here for Clickable to update its state.
    isDisabled: isReadonly,
    omitFocusRing: true,
    isHovered: isHovered,
    isActive: isActive,
    isOpen: isOpen,
    clientId: (0, _lodestarUtils.getClientId)(clientId, "-toggle"),
    themeMode: themeMode
  }), /*#__PURE__*/_react.default.createElement(_ToggleButtonIcon.ToggleButtonIcon, null));
});
exports.ToggleButton = ToggleButton;
ToggleButton.displayName = "ToggleButton";
//# sourceMappingURL=ToggleButton.js.map